/**
 * Filet global : un toast ne reçoit JAMAIS un objet brut (25/10/2026).
 *
 * Prouvé en production le 25/10/2026 01:44 UTC sur /register (Android) :
 * « Minified React error #31 … object with keys {type, loc, msg, input, ctx} ».
 * Un 422 FastAPI renvoie `detail` sous forme de TABLEAU d'objets ; plus de 150
 * appels font `toast.error(err.response?.data?.detail || "…")`, et l'inscription
 * plantait au lieu d'afficher « adresse e-mail invalide ». `apiErrMsg` règle le
 * cas appel par appel ; ce filet le règle pour tous, y compris les futurs.
 */
import { isValidElement } from "react";
import { toast } from "sonner";

const PAR_DEFAUT = "Une erreur est survenue";

// Messages de validation Pydantic (anglais) → phrase française lisible.
const TRADUCTIONS = [
  [/^value is not a valid email address/i, "Adresse e-mail invalide : vérifiez-la (un seul @, sans espace)."],
  [/^field required/i, "Un champ obligatoire est vide."],
  [/^string should have at least/i, "Un champ est trop court."],
];

function traduire(msg) {
  for (const [motif, fr] of TRADUCTIONS) if (motif.test(msg)) return fr;
  return msg;
}

export function texteAffichable(v) {
  if (v == null || typeof v === "string" || typeof v === "number" || isValidElement(v)) return v;
  if (typeof v === "function") return v;
  if (Array.isArray(v)) {
    const t = [...new Set(v.map((x) => traduire(typeof x === "string" ? x : x?.msg || x?.message || "")).filter(Boolean))].join(" ");
    return t || PAR_DEFAUT;
  }
  if (typeof v === "object") return v.msg || v.message || v.detail && texteAffichable(v.detail) || PAR_DEFAUT;
  return String(v);
}

let installe = false;

export function installerToastTexteSur() {
  if (installe) return;
  installe = true;
  for (const nom of ["error", "warning", "info", "success", "message"]) {
    const original = toast[nom];
    if (typeof original !== "function") continue;
    toast[nom] = (message, options) => original(texteAffichable(message), options);
  }
}
